(function () {
	'use strict';

	angular.module('l4b')
		.component('enrollmentShow', {
			templateUrl: 'html/shared/enrollmentShow/enrollmentShow.html',
			bindings: {
				enrollmentNumber: '<'
			},			
			controller: EnrollmentShowController,
			controllerAs: 'vm',
			
			
		});

	EnrollmentShowController.$inject = ['Constants',  'FlowService', 'BrandService'];

	function EnrollmentShowController(Constants, FlowService, BrandService) {

		var vm = this;

		angular.extend(vm, {
			goToMyAccount: goToMyAccount,
			isVzBrand: BrandService.getCurrent().Code == Constants.Brand.VZ.Code,
			isFtrBrand: BrandService.getCurrent().Code == Constants.Brand.FTR.Code,
		});

		function goToMyAccount() {
			FlowService.goToMyAccount();
		}
	}
})();
